import { FC } from "react";
import { Field, FieldProps, FormikProps } from 'formik';
import { FeedbackMessage, FieldControl } from "src/UI";
import { DateBox } from "src/Controls";
import DateFormater from "src/Utils/DateFormater";

interface IDateTimeFieldProps {
	name: string;
	title: string;

	setData?: Function;
	isRequired?: boolean;
	disabled?: boolean;

	withTime?: boolean;
	needParse?: boolean;

	minDate?: string | Date;
	maxDate?: string | Date;
};

/**
 * Текстовое поле
 */
const DateTimeField: FC<IDateTimeFieldProps> = ( props ) => {

	const { name, title, setData, isRequired = false, disabled = false, needParse = false } = props;

	const onSetValue = ( form: FormikProps<any>, value: Date | null ) => {
		let val: any = value;
		if ( needParse )
			val = DateFormater.toShortString( value );
		form.setFieldTouched(name, true);
		form.setFieldValue(name, val );
		!!setData && setData((data: any) => {
			return { ...data, [name]: val }
		});
	};

	/** Возвращает строкое представление значения */
	const getDateValue = ( value: Date | string, needParse: boolean = false ): string => {
		if ( typeof value === "object" && !!value?.getTime ) {
			return DateFormater.toShortString(value);
		} 
		else if ( !needParse && !!value ) {
			const date = new Date(value);
			return DateFormater.toShortString(date);
		}
		return value?.toString() || "";
	};

	const getMaxDate = (): Date|undefined => {
		const val = props.maxDate;
		if ( !val ) return undefined;
		if ( val === "today" ) {
			const tmp = new Date( Date.now() );
			return new Date( tmp.getFullYear(), tmp.getMonth(), tmp.getDate(), 0,0,0,0 );
		}
	};

	const renderInnerField = ( { form, meta, field }: FieldProps ) => {
		const value = getDateValue(field.value, needParse);
		return (
			<FieldControl
				name={name}
				isRequired={isRequired}
				title={title}
			>
				<DateBox
					name={name}
					variant="blueControl"
					disabled={disabled}
					value={value} 
					setValue={ v => onSetValue( form, v )}
					maxDate={getMaxDate()}
					isError={!!meta.error && meta.touched}
				/>
				{(meta.error && meta.touched) && <FeedbackMessage message={meta.error} /> }
			</FieldControl>
		);
	};

	return (
		<Field id={name} name={name}>
			{ renderInnerField }
		</Field>
	);
};

export default DateTimeField;
